import React from 'react'
import { withTranslation } from 'react-i18next'
import FilterPill from '../../shared/FilterPill'
import SearchInput from '../../shared/SearchInput'

export default withTranslation()(function BranchFilterBar({ t, q, onChangeQ, locations = [], location, onChangeLocation, status, onChangeStatus }) {
  const locationOptions = [
    { label: t('settings.branch.filters.all_locations'), value: '' },
    ...locations.map((name) => ({ label: name, value: name }))
  ]

  const statusOptions = [
    { label: t('settings.branch.filters.all_statuses'), value: '' },
    { label: t('settings.branch.filters.active'), value: 'active' },
    { label: t('settings.branch.filters.inactive'), value: 'inactive' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <SearchInput
        value={q}
        onChange={onChangeQ}
        placeholder={t('settings.branch.filters.search_placeholder')}
      />

      <FilterPill
        label={t('settings.branch.filters.all_locations')}
        active={location ? { label: location } : null}
        options={locationOptions}
        showSearch
        searchPlaceholder={t('settings.branch.filters.search_location_placeholder')}
        onSelect={(option) => onChangeLocation(option.value)}
      />

      <FilterPill
        label={t('settings.branch.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
      />
    </div>
  )
})
